// extracted by mini-css-extract-plugin
export var button = "_j0-0";
export var donut = "_j0-1";
export var donutFill = "_j0-3";
export var donutTrack = "_j0-2";